const getters = {
    isDisabledForm: (state) => {
        return !state.item || state.isFetching || state.isSaving
    },
}

export default getters
